<template>
    <svg viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M28.5 18L7.5 18" stroke="#777777" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M18 28.5L7.5 18L18 7.5" stroke="#777777" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>

<script>
    export default {
        name: "BackIcon"
    }
</script>

<style scoped>

</style>